import { Component, OnInit, Input, NgZone, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@ionic/angular';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File, IWriteOptions, FileEntry } from '@ionic-native/file/ngx';


@Component({
  selector: 'app-file-upload',
  templateUrl: './app-file-upload.component.html' 
})
export class AppFileUploadComponent implements OnInit {

    @Input() objToSet: any = {
        attachment: '',
        filePath:''         
      };
    @Output() onFileEncoded = new EventEmitter();
    @Output() onFileCleared = new EventEmitter();

    fileName;
    showFileName;
    isImageFile;
    uploadId;
    imagePath;
  constructor( private sanitizer: DomSanitizer,
    private platform: Platform,
    private camera: Camera,
    private file:File) { 
  }

  ngOnInit() {   
  }

  selectImage(event){

    if (!this.platform.is('cordova')) {
      this.onFileChange(event)
      return;
    }
    
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }
   
    this.camera.getPicture(options).then((imageData) => {     
      this.file.resolveLocalFilesystemUrl(imageData).then((entry: FileEntry) => { 
        entry.file(file => { 
          this.objToSet.filePath = file; 
          this.readFile(file); 
          }); 
          }); 
    }, (err) => {
      console.log(err);
    });
  }

  onFileChange(event) {   
      
    if (event.target.files.length > 0) {
       const file = event.target.files[0];
       this.fileName = file.name;
       this.objToSet.filePath = file;
 
      this.readFile(file);
      /* var FR = new FileReader();
 
       FR.addEventListener("load", (e: any) => {
         this.objToSet.attachment = e.target.result;
         this.showFileName = true;
     
         this.checkFileIsImage();
 
         this.onFileEncoded.emit(this.objToSet);
       });
 
       FR.readAsDataURL(file);*/
     }
   }

  

   readFile(file:any){ 
     var FR = new FileReader(); 
     FR.addEventListener("load", (e: any) => {
       this.objToSet.attachment = e.target.result; 
       this.showFileName = true; 
       this.checkFileIsImage();
      this.onFileEncoded.emit(this.objToSet); 
      });
      FR.readAsDataURL(file); 
 }

 

  clearFile() {
    this.showFileName = false;
    this.objToSet.attachment = '';
    this.onFileCleared.emit();
  }

  setFile() {
    if (this.objToSet.attachment) {
      this.showFileName = true;
      this.checkFileIsImage();
    }
  }

  checkFileIsImage(){
    const urls = this.objToSet.attachment.split(";");
    this.isImageFile = urls[0].indexOf("image/") !== -1;
  }

  getSanitizeUrl() {
    return this.sanitizer.bypassSecurityTrustUrl(this.objToSet.attachment);
  }
}